import Phone from '@material-ui/icons/Phone';
import Room from '@material-ui/icons/Room';
import { OrangeButton } from 'components/Button';
import { Captions } from 'components/Typography';
import { sanlamBlue } from 'Material-UI/colors';
import { Info } from 'react-feather';
import styled from 'styled-components';

export const StyledCaptions = styled(Captions)`
  && {
    margin-bottom: 0;
  }
`;
export const StyledIconInfo = styled(Info)`
  && {
    cursor: pointer;
  }
`;

export const StyledAddress = styled(Captions)`
  && {
    margin-bottom: 0;
    color: gray;
  }
`;

export const StyledButton = styled(OrangeButton)`
  && {
    max-width: 200px;
    margin-top: 10px;
    padding: 10px;
  }
`;

export const PhoneIcon = styled(Phone)`
  && {
    color: ${sanlamBlue};
    cursor: pointer;
  }
`;

export const LocationIcon = styled(Room)`
  && {
    color: ${sanlamBlue};
    cursor: pointer;
    margin-left: 10px;
  }
`;
